'useClient';

import { Notification } from '@packages/shared/src/ui/Notification/Notification';
import { useIntl } from 'react-intl';

export type SampleOrderErrorFallbackProps = {
  onCloseHandler?(): void;
};

export const SampleOrderErrorFallback = ({ onCloseHandler }: SampleOrderErrorFallbackProps) => {
  const { formatMessage } = useIntl();

  return (
    <Notification onClose={onCloseHandler} severity="warning">
      {formatMessage({
        id: 'so-errorFallback-message',
        defaultMessage:
          'Aus technischen Gründen ist die Musterbestellung momentan nicht möglich. Bitte lade die Seite erneut oder versuche es später noch einmal.',
      })}
    </Notification>
  );
};
